import styled from 'styled-components';
import { TextButton } from '@riac/design-system';
import { theme } from '@riac/design-system';

export const NoResultsStyles = styled.div`
  div {
    padding: 1em 0;
    color: black;
    padding-bottom: 0.25rem;
  }

  div > div
  {
    padding-top: 0;
  }
  
  p {
    color: black;
    padding-bottom: 1em;
    max-width: 600px;
  }
  
  .suggestionsContainer {
    display: flex;
    flex-flow: row wrap;
    padding: 0;
    max-width: 600px;
    margin-bottom: 0.5em;

    li {
      list-style: none;
    }
   
    div{
      flex: 1 auto auto;
      padding: 0;
      padding-bottom: 0.5em;
    }

    ${TextButton} {
      margin: 0 1em 0.5em 0;
      text-decoration: underline;
      ${theme.mediaScalingFont(1.6)}
      &:first-child {
        margin-left: 2rem;
      }
    }
  }

  ul{
    padding-left: 1em;
    color: black;
    margin-top: 0.5em;
  }
`;

